import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getAllUserCompaniesApi = async () => {
    return vdkEmHappinessPortalApi.get('/companies/get-all-user-company');
};
const getAllCompaniesApi = async () => {
    return vdkEmHappinessPortalApi.get('/companies/get-all');
};
const updateCompanyApi = async (dto) => {
    const formData = new FormData();
    formData.append('Id', dto.id);
    formData.append('Name', dto.name);
    formData.append('Email', dto.email);
    formData.append('PhoneNo', dto.phoneNo);
    formData.append('Region', String(dto.region));
    if (dto.perCompanyEventSlots != null)
        formData.append('PerCompanyEventSlots', String(dto.perCompanyEventSlots));
    if (dto.companyPerDayEventSlots != null)
        formData.append('CompanyPerDayEventSlots', String(dto.companyPerDayEventSlots));
    if (dto.legalGroup)
        formData.append('LegalGroup', dto.legalGroup);
    if (dto.logo)
        formData.append('Logo', dto.logo);
    return vdkEmHappinessPortalApi.post('/companies/update', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
const deleteCompanyApi = async (id) => {
    return vdkEmHappinessPortalApi.delete(`/companies/${id}`);
};
const CompanyApi = {
    getAllUserCompaniesApi,
    getAllCompaniesApi,
    updateCompanyApi,
    deleteCompanyApi
};
export default CompanyApi;
